import type { ListNoDataTheme } from '../ListNoDataStyles.css';

import { listNoDataStyles, variants } from '../ListNoDataStyles.css';
import { multiVariantStyles } from './ListNoDataVariants.css';

export const ListNoDataStableTheme: ListNoDataTheme = {
  multiVariantStyles,
  variants,
  styles: listNoDataStyles
};
